import Organizations from 'components/admin/organizations'
import { switchClient, fetchOrganizations } from 'api/user'
import ImpersonateCheck from 'components/impersonate-check'
import { clearIntegrationData } from 'common/integrationUtils'

export default function OrganizationsComponent() {
  const [impersonate, setImpersonate] = useState()
  const dispatch = useDispatch()
  const organizations = useSelector((state) => state.account.organizations)
  const token = useSelector((state) => state.account['token'])

  useEffect(() => {
    setImpersonate(!!localStorage.getItem('impersonate'))
  }, [])

  useEffect(() => {
    if (typeof impersonate === 'undefined' && token) {
      dispatch(fetchOrganizations())
    } else {
      setImpersonate(impersonate)
    }
  }, [impersonate])

  const onClickSwitch = useCallback((c) => {
    clearIntegrationData()
    dispatch(switchClient(c.tenantId))
    //Remove the CFF localStorage items
    localStorage.removeItem('selectedClient')
    localStorage.removeItem('selectedFarms')
    //End
  })

  const onClickSwitchWizard = useCallback((c) => {
    clearIntegrationData()
    dispatch(switchClient(c.tenantId, { wizard: true }))
    //Remove the CFF localStorage items
    localStorage.removeItem('selectedClient')
    localStorage.removeItem('selectedFarms')
    //End
  })

  const el = useMemo(() => {
    return (
      <ImpersonateCheck showMessage={true}>
        <Organizations
          organizations={organizations}
          onClick={onClickSwitch}
          onClickWizard={onClickSwitchWizard}
        />
      </ImpersonateCheck>
    )
  }, [impersonate, organizations])

  return <>{el}</>
}
